export enum LoggingLevel {
	Debug = 'debug',
	Info = 'info',
	Warn = 'warn',
	Error = 'error',
}

export enum LoggingService {
	Console = 'console',
	Bugfender = 'bugfender',
}

export enum LogLevel {
	Debug = 0,
	Info = 1,
	Warn = 2,
	Error = 3,
}
